import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import LoadingSpinnerCover from "src/components/LoadingSpinnerCover";
import UpToDate from "src/components/UpToDate";
import { fetchClientPlacements } from "../../reducers/ClientPlacementsReducer";
import store from "../../store";
import ClientHistoryTable from "./ClientHistoryTable";
import CsvGeneratorModal from "./CsvGenerator";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  row: {
    color: "black",
  },
}));

const ClientHistory = ({ completePlacements = [], isLoading, userToken }) => {
  const classes = useStyles();
  const [state, setState] = useState({
    completePlacements,
  });

  useEffect(() => {
    store.dispatch(fetchClientPlacements);
  }, []);

  useEffect(() => {
    setState((s) => {
      return {
        ...s,
        completePlacements,
      };
    });
  }, [completePlacements]);

  if (isLoading) {
    return <LoadingSpinnerCover />;
  }

  if (!completePlacements?.length) {
    return <UpToDate />;
  }

  return (
    <div className={classes.root}>
      {completePlacements?.length ? (
        <>
          <ClientHistoryTable
            placements={state.completePlacements}
            useStyles={useStyles}
            checkboxes={true}
            userToken={userToken}
          />
          <CsvGeneratorModal placements={completePlacements} />
        </>
      ) : null}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    completePlacements: state.clientPlacementsReducer.completePlacements,
    isLoading: state.userPlacementsReducer.isLoading,
    userToken: state.userTokenReducer.userToken,
    employees: state.userPlacementsReducer.employees,
  };
}

export default connect(mapStateToProps)(ClientHistory);
